/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, CardBody } from 'react-bootstrap'; // eslint-disable-next-line
import avatar_img from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, getLanguagePackUrl } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import UserProfileTopSection from './UserProfileTopSection';
import UserProfileContentSection from './UserProfileContentSection';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
import './profile_modal.css';
const UserProfileModal = ({ showHide, className, onClick, count, profileId = 564743139 }) => {
	const [showHideLoader, setShowHideLoader] = useState(false); // eslint-disable-next-line
	const [data, setData] = useState([]); // eslint-disable-next-line
	const [loginHistoryData, setLoginHistoryData] = useState([]); // eslint-disable-next-line
	const [avatar, setAvatar] = useState(avatar_img); // eslint-disable-next-line
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const [showCardSection, setShowCardSection] = useState(false); // eslint-disable-next-line
	const [currentActiveTab, setCurrentActiveTab] = useState('1');
	const [showHideModalContent, setShowHideModalConten] = useState(false);
	const [userAddressData, setUserAddressData] = useState(false);
	useEffect(() => {
		if (showHide) {
			var id = profileId;
			setShowHideLoader(true);
			var checkData = JSON.parse(localStorage.getItem('idiom'));
			if (checkData === null || checkData === undefined || checkData === '') {
				var getLanguageURL = getLanguagePackUrl();
				copiriPortalRequest(getLanguageURL, config.app_version, 'get')
					.then(response => {
						if (response.data.result.PRL) {
							setPageLanguageContent(response.data.result.PRL);
							localStorage.setItem('idiom', JSON.stringify(response.data.result));
						}
						getUserProfileData(id);
						getUserAddressData(id, 'addresses');
					})
					.catch(error => {
						setShowHideLoader(false);
					});
			} else {
				if (checkData.PRL) {
					setPageLanguageContent(checkData.PRL);
				}
				getUserProfileData(id);
				getUserAddressData(id, 'addresses');
			}
		}
		// eslint-disable-next-line
	}, [showHide]);

	function getUserProfileData(id) {
		setShowHideModalConten(false);
		copiriPortalRequest('/users/' + id + '?format=detailed', config.app_version, 'get', data)
			.then(response => {
				setData(response.data.result);
				setShowHideModalConten(true);
				if (response.data.result.partial) {
					setShowCardSection(true);
				} else {
					setShowCardSection(false);
				}
				setLoginHistoryData(response.data.result.login_history);
				setShowHideLoader(false);
			})
			.catch(error => {
				setData([]);
				setShowCardSection(false);
				setShowHideLoader(false);
				setShowHideModalConten(false);
			});
	}

	function getUserAddressData(id, type) {
		copiriPortalRequest('/users/' + id + '/' + type, config.app_version, 'get')
			.then(response => {
				setUserAddressData(response?.data?.result);
			})
			.catch(error => {
				setUserAddressData([]);
			});
	}

	/* Function to delete user*/
	// eslint-disable-next-line
	const deleteUser = e => {
		e.preventDefault();
	};
	// eslint-disable-next-line
	const updateData = (
		id,
		inputFields,
		date = '',
		field = '',
		memebrId = '',
		updatedData,
		orgId = '',
		type,
		parentChild = ''
	) => {
		if (date !== '') {
			let birthdate = date;
			setData({ ...data, birthdate });
		} else if (field && field !== '') {
			let memberships = data['memberships'];
			if (memberships && memberships.length > 0) {
				for (let i = 0; i < memberships.length; i++) {
					if (type && type === 'memberShipStatus') {
						if (memberships[i]['id'] === memebrId) {
							memberships[i]['status_id'] = parseInt(updatedData);
						}
						if (parentChild && parentChild === 'parent') {
							if (memberships[i]['parent_id'] === orgId) {
								memberships[i]['status_id'] = parseInt(updatedData);
							}
						} else {
							if (memberships[i]['org_id'] === orgId) {
								memberships[i]['status_id'] = parseInt(updatedData);
							}
						}
					}
					if (type && type === 'memberShipNumber') {
						if (memberships[i]['id'] === memebrId) {
							memberships[i]['member_number'] = updatedData;
						}
						if (parentChild && parentChild === 'parent') {
							if (memberships[i]['parent_id'] === orgId) {
								memberships[i]['member_number'] = updatedData;
							}
						} else {
							if (memberships[i]['org_id'] === orgId) {
								memberships[i]['member_number'] = updatedData;
							}
						}
					}
					if (type && type === 'memberShipOffice') {
						if (memberships[i]['id'] === memebrId) {
							memberships[i]['role'] = updatedData;
						}
					}
				}
			}
			setData({
				...data,
				memberships
			});
		} else {
			// eslint-disable-next-line
			const {
				first_name,
				last_name,
				middle_name,
				name_full,
				name_pref,
				suffix_id,
				suffix,
				second_last_name,
				gender_id,
				gender,
				email,
				phone
			} = inputFields;
			let spouse = {};
			spouse['first_name'] = inputFields['spouse_first_name'];
			spouse['middle_name'] = inputFields['spouse_middle_name'];
			spouse['last_name_one'] = inputFields['spouse_last_name'];
			spouse['name_full'] =
				inputFields['spouse_first_name'] +
				' ' +
				(inputFields['spouse_last_name'] ? inputFields['spouse_last_name'] : '');
			spouse['preferred_name'] = inputFields['spouse_preferred_name'];
			spouse['sex_id'] = inputFields['spouse_gender_id'];
			spouse['suffix_id'] = inputFields['spouse_suffix'];
			spouse['last_name_two'] = inputFields['spouse_second_last_name'];
			setData({
				...data,
				first_name,
				last_name,
				middle_name,
				name_pref,
				name_full,
				suffix_id,
				suffix,
				second_last_name,
				spouse,
				gender_id,
				gender,
				email,
				phone
			});
		}
	};
	return (
		<div>
			<Modal
				show={showHide}
				onHide={onClick}
				className=''
				id='profile_modal'
				size='xl'
				aria-labelledby='example-modal-sizes-title-lg'
			>
				{showHideLoader ? (
					<CopiriLoader />
				) : (
					<>
						<ModalHeader onHide={onClick} closeButton>
							<Modal.Title></Modal.Title>
						</ModalHeader>
						<ModalBody className='p-0 grey-bg'>
							{showHideModalContent ? (
								<CardBody className='p-0'>
									<UserProfileTopSection
										data={data}
										pageLanguageContent={pageLanguageContent}
										showCardSection={showCardSection}
										userAddressData={userAddressData}
									/>
									<UserProfileContentSection
										data={data}
										pageLanguageContent={pageLanguageContent}
										updateData={updateData}
										profileId={profileId}
										userAddressData={userAddressData}
									/>
								</CardBody>
							) : (
								<CardBody className='pt-2'>
									<Row>
										<Col lg={12} className='text-center'>
											<div className='profile-card-info'>
												<p>
													<strong>{pageLanguageContent['PRL086'] ? pageLanguageContent['PRL086'] : ''}</strong>
												</p>
											</div>
										</Col>
									</Row>
								</CardBody>
							)}
						</ModalBody>
						<ModalFooter>
							{showHideModalContent && (
								<Button variant='secondary' onClick={onClick}>
									{genPageData['GENCLS'] ? genPageData['GENCLS'] : ''}
								</Button>
							)}
						</ModalFooter>
					</>
				)}
			</Modal>
		</div>
	);
};
export default UserProfileModal;
